var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.input ? _c('span', [_vm._v("\n  " + _vm._s(_vm.input) + " " + _vm._s(_setup.postFix) + "\n")]) : _c('span', [_vm._v("\n  " + _vm._s(_vm.empty) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };